import { useCallback, useEffect, useState } from 'react';
import { getReceiptCapabilities } from '@/services/bff/receipt-workflow.api';
import type { ReceiptCapabilities } from '@/services/bff/types/receipt-workflow';
export function useReceiptCapabilities() {
  const [capabilities, setCapabilities] = useState<ReceiptCapabilities>({
    enabled: false,
    reason: '正在检查回款能力',
    actions: {},
  });
  const [loading, setLoading] = useState(true);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true);
    getReceiptCapabilities()
      .then((result) => {
        if (active)
          setCapabilities(
            result && typeof result.enabled === 'boolean'
              ? result
              : { enabled: false, reason: '回款能力响应不完整', actions: {} },
          );
      })
      .catch(() => {
        if (active)
          setCapabilities({
            enabled: false,
            reason: '无法检查上游回款能力，请重试',
            actions: {},
          });
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [attempt]);
  return {
    capabilities,
    loading,
    refresh: useCallback(() => setAttempt((value) => value + 1), []),
  };
}
